module.exports = __webpack_public_path__ + "img/mesa_l001nh.e96ee202.png";